import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import UIScrollComponent from 'Component/UI/Scroll';

interface IScrollToPositionMeta {
    duration: number;
    startPosition: number;
    endPosition: number;
    delay?: number;
    onComplete?: () => void;
}

export class ScrollToPosition extends AnimationClip<IScrollToPositionMeta> {
    public *execute(
        gameObject: GameObject,
        meta: IScrollToPositionMeta
    ): IterableIterator<number> {
        const scroll = gameObject.getComponent(UIScrollComponent);

        const scrollPosition = { value: meta.startPosition };
        const tween = this.getTween(scrollPosition);

        tween
            .to({ value: meta.endPosition }, meta.duration)
            .easing(Easing.Linear.None)
            .onUpdate((object) => {
                scroll.UIComponent.scrollToPosition(object.value, 0);
            });

        yield* this.startTween(tween);

        if (meta.onComplete) {
            meta.onComplete();
        }
    }
}
